import { type FC } from "react";

// Markup transcribed from the design port kit (sections/Loop.html).
export const ReviewLoop: FC = () => (
  <section className="pad loop">
    <div className="wrap">
      <h2>Want another set of eyes before it leaves your office?</h2>
      <p>
        Add expert human review to any case: a human reviewer and an AI
        reviewer, each checking the other’s work.
      </p>
      <p>
        When our reviewers catch something, the workflow itself gets updated.
        The system gets sharper with every case.
      </p>
    </div>
  </section>
);
